//Import
import routerGuard from '@/helpers/routerGuard'

const routes = [

    {
        path: '/user',
        name: 'Manage Sub-Admins',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/adminusers/userlist.vue'),
        meta: { moduleCode: 2002 }
    },
    {
        path: '/loginCompanyUser/:UserName/:origin/:companyUrl',
        name: 'Company User Login',
        component: () =>
            import ('@/views/login/loginCompanyUser.vue')
    },
    {
        path: '/mobileDashboard',
        name: 'mobileDashboard',
        component: () =>
            import ('@/views/login/mobileDashboard.vue')
    },
    {
        path: '/user/adduser',
        name: 'Manage Sub-Admins  | Add Sub-Admin',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/adminusers/addedituser.vue'),
        meta: { moduleCode: 2002 }
    },
    {
        path: '/user/addeditUser/:id',
        name: 'Manage Sub-Admins | Edit Sub-Admin',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/adminusers/addedituser.vue'),
        meta: { moduleCode: 2002 }
    },
    {
        path: '/expenses',
        name: 'ExpenseList',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/Expense/expenselist.vue'),
        meta: { moduleCode: 12802 }
    },
    {
        path: '/expenses/create',
        name: 'ExpenseCreate',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/Expense/expenseaddedit.vue'),
        meta: { moduleCode: 12802 }
    },
    {
        path: '/expenses/edit/:id',
        name: 'ExpenseEdit',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/Expense/expenseaddedit.vue'),
        meta: { moduleCode: 12802 }
    },
    {
        path: '/expenses/voting/:expenseId/:assetId',
        name: 'ExpenseVotingDetails',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Expense/ExpenseVotingDetails.vue'),
        meta: { moduleCode: 12802 }
    },
    {
        path: '/expenses/dues',
        name: 'ExpenseAndDue',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/expenses/ExpenseAndDue.vue')
        ,
        meta: { moduleCode: 12803 }
    },
    {
        path: '/paymenttracking',
        name: 'PaymentTracking',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Expense/paymenttracking.vue'),
        meta: { moduleCode: 12802 }
    },
    {
        path: '/expense/settings',
        name: 'ExpenseSettings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Expense/ExpenseSettings.vue'),
        meta: { moduleCode: 12802 }
    },
    {
        path: '/meetings',
        name: 'MeetingList',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ZoomMeeting/meetinglist.vue')
        ,
        meta: { moduleCode: 12805 }
    },
    {
        path: '/meetings/add',
        name: 'MeetingAdd',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ZoomMeeting/addmeeting.vue'),
       meta: { moduleCode: 12805 }
    },
    {
        path: '/ticket',
        name: 'ManageTickets',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/CompanyUserView/ManageTicket/ticketList.vue'),
        meta: { moduleCode: 7011 }
    },
    {
        path: '/voting-proposals',
        name: 'VotingProposals',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/voting/VotingProposals.vue')
        , meta: { moduleCode: 12804 }
    },
    {
        path: '/account/forgot-password',
        name: 'Forgot-Password',
        component: () =>
            import ('@/views/Account/forgot-password/forgot-password.vue')
    },
    {
        path: '/account/resetpassword',
        name: 'Reset Password',
        component: () =>
            import ('@/views/Account/reset-password/reset-password.vue')
    },
    {
        path: '/account/setpassword',
        name: 'Set Password',
        component: () =>
            import ('@/views/Account/setpassword/setpassword.vue')
    },
    {

        path: '/EmployeeList',
        name: 'Employee',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/AuthorsView.vue'),
        children: [{
                path: '/EmployeeList',
                component: { template: '<router-view></router-view>' }
            },
            {
                path: 'add',

                component: () =>
                    import ('@/views/AddEditEmployee.vue'),
            },
            {
                path: 'edit/:id',

                component: () =>
                    import ('@/views/AddEditEmployee.vue')
            }
        ]
    },
    {
        path: '/add',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/AddEditEmployee.vue'),
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/dashboard/dashboardinitializer.vue'),
        meta: { moduleCode: 2312 }
    },
    {
        path: '/CompanyadmindashboardNew',
        name: 'CompanyAdminDashboardNew',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/dashboard/companyadmindashboard/CompanyadmindashboardNew.vue'),
        meta: { moduleCode: 2312 }
    },
    {
        path: '/onboardinglist',
        name: 'Onboarding Checklist',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/dashboard/onboardinglist.vue'),
        meta: { moduleCode: 2312 }
    },
    {
        path: '/onboarding',
        name: 'Onboarding Wizard',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/dashboard/onboarding.vue'),
        meta: { moduleCode: 2312, hideLayout: true }
    },
    {
        path: '/role',
        name: 'Manage Roles',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managerole/rolelist.vue'),
        meta: { moduleCode: 2003 }
    },

    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        beforeEnter: routerGuard.LoginGuard,
        component: () =>
            import ('@/views/login/login.vue'),
        meta: { showHeader: false, showSidebar: false }
    },
    {

        path: '/role/addeditrole',
        name: 'Manage Roles | Add Role',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/managerole/addeditrole.vue'),
        meta: { moduleCode: 2003 }
    },
    {

        path: '/role/editrole/:id',
        name: 'Manage Roles | Edit Role',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/managerole/addeditrole.vue'),
        meta: { moduleCode: 2003 }
    },
    {
        path: '/emailsettings',
        name: 'Manage SMTP Settings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/emailsettings/emailsettings.vue'),
        meta: { moduleCode: 5211 }
    },
    {
        path: '/subscriptions',
        name: 'Manage Packages',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managesubscription/subscriptionList.vue'),
        meta: { moduleCode: 4022 }
    },
    {
        path: '/subscriptions/create',
        name: 'Manage Packages  | Add/Edit Package',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managesubscription/addeditsubscription.vue'),
        meta: { moduleCode: 4022 }
    },
    {
        path: '/subscriptions/edit/:id',
        name: 'Manage Packages | Add/Edit Package',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managesubscription/addeditsubscription.vue'),
        meta: { moduleCode: 4022 }
    },
    {
        path: '/emailtemplates',
        name: 'Email Templates',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageemailtemplate/emailtemplatelisting.vue'),
        meta: { moduleCode: 4021 }
    },
    {
        path: '/emailtracking',
        name: 'Email Tracking',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageemailtemplate/emailtrackinglisting.vue'),
        meta: { moduleCode: 4523 }
    },
    //{
    //    path: '/paymentsettings',
    //    name: 'Manage Payment Settings',
    //    component: () =>
    //    import('@/views/ManagePaymentSettings/paymentsettings.vue'),
    //    meta: { moduleCode: 5215 }
    //},

    ///New component ManagePaymentSettings 
    {
        path: '/paymentsettings',
        name: 'Manage Payment Settings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManagePaymentSettings/ManagePaymentSettings.vue'),
        meta: { moduleCode: 5215 }
    },

    {
        path: '/emailtemplates/addeditemailtemplate',
        name: 'Add Email Template',
        component: () =>
            import ('@/views/manageemailtemplate/addeditemailtemplate.vue')
    },
    {
        path: '/emailtemplates/addeditemailtemplate/:id',
        name: 'Email Templates | Edit Email Template',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageemailtemplate/addeditemailtemplate.vue'),
        meta: { moduleCode: 4021 }
    },
    {
        path: '/userProfile',
        name: 'My Profile',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/UserProfile/UserProfile.vue')
    },
    {
        path: '/company',
        name: 'Manage Companies',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompany/companyList.vue'),
        meta: { moduleCode: 4023 }
    },
    {
        path: '/company/create',
        name: 'Manage Companies  | Add/Edit Company',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompany/AddCompany.vue'),
        meta: { moduleCode: 4023 }
    },
    {
        path: '/company/edit/:id',
        name: 'Manage Companies | Add/Edit Company',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompany/AddCompany.vue'),
        meta: { moduleCode: 4023 }
    },
    {
        path: '/company/profile',
        name: 'Manage Companies | Update Company Profile',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompany/UpdateCompanyProfile.vue'),
        meta: { moduleCode: 4023 }
    },
    {
        path: '/assetCategory',
        name: 'Manage Assets Categories',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/assetcategory/assetcategorylist.vue'),
        meta: { moduleCode: 6001 }
    },
    {
        path: '/assetcategory/addassetcategory',
        name: 'Manage Assets Categories | Add Asset Category',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/assetcategory/addeditassetcategory.vue'),
        meta: { moduleCode: 6001 }
    },
    {
        path: '/assetcategory/editassetcategory/:id',
        name: 'Manage Assets Categories | Edit Asset Category',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/assetcategory/addeditassetcategory.vue'),
        meta: { moduleCode: 6001 }
    },

    ,
    {
        path: '/managelayoutlist',
        name: 'Manage Layout',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managelayout/managelayoutlist.vue'),
        meta: { moduleCode: 4045 }
    },
    {
        path: '/managelayout/editLayout/:id',
        name: 'Edit Layout',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managelayout/addeditlayout.vue'),
        meta: { moduleCode: 4045 }
    },
    {
        path: '/membership',
        name: 'Manage Memberships',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managemembership/membershiplist.vue'),
        meta: { moduleCode: 4044 }
    },
    {
        path: '/membership/create',
        name: 'Manage Memberships  | Add/Edit Membership',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managemembership/addeditmembership.vue'),
        meta: { moduleCode: 4044 }

    },
    {
        path: '/membership/edit/:id',
        name: 'Manage Memberships | Add/Edit Membership',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managemembership/addeditmembership.vue'),
        meta: { moduleCode: 4044 }

    },
    {
        path: '/blogcategories/Addupdateblog',
        name: 'Manage Blogs Category | Add/Edit Blog Category',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/blogcategories/Addupdateblog.vue'),
        meta: { moduleCode: 8003 }
    },
    {
        path: '/blogcategories',
        name: 'Manage Blogs Categories',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/blogcategories/blogList.vue'),
        meta: { moduleCode: 8003 }
    },
    {
        path: '/blogcategories/edit/:id',
        name: 'Manage Blog Categories | Add/Edit Blog Category',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/blogcategories/Addupdateblog.vue'),
        meta: { moduleCode: 8003 }
    },
    {
        path: '/contactus',
        name: 'Contact Us Queries',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/Contacus/contactus.vue'),
        meta: { moduleCode: 8001 }
    },
    {
        path: '/manageblog',
        name: 'Manage Blogs',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageblogs/manageblog.vue'),
        meta: { moduleCode: 8004 }
    },
    {
        path: '/manageblog/create',
        name: 'Manage Blogs  | Add/Edit Blog',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageblogs/addupdateblog.vue'),
        meta: { moduleCode: 8004 }

    },
    {
        path: '/manageblog/edit/:id',
        name: 'Manage Blogs | Add/Edit Blog',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageblogs/addupdateblog.vue'),
        meta: { moduleCode: 8004 }
    },
    {
        path: '/subscriptiondetails',
        name: 'My Packages',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/companysubscription/subscriptiondetails.vue'),
        meta: { moduleCode: 5212 }

    },
    {
        path: '/news',
        name: 'Manage Press Release',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managenews/newsList.vue'),
        meta: { moduleCode: 8005 }
    },
    {
        path: '/news/create',
        name: 'Manage Press Release  | Add/Edit Press Release',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managenews/addeditnews.vue'),
        meta: { moduleCode: 8005 }
    },
    {
        path: '/news/edit/:id',
        name: 'Manage Press Release | Add/Edit Press Release',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managenews/addeditnews.vue'),
        meta: { moduleCode: 8005 }
    },
    {
        path: '/newsletter',
        name: 'Manage Newsletters',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managenewsletter/newsletterlist.vue'),
        meta: { moduleCode: 8010 }
    },
    {
        path: '/newsletter/create',
        name: 'Manage Newsletters  | Add/Edit Newsletter',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managenewsletter/addeditnewsletter.vue'),
        meta: { moduleCode: 8010 }

    },
    {
        path: '/newsletter/edit/:id',
        name: 'Manage Newsletters | Add/Edit Newsletter',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managenewsletter/addeditnewsletter.vue'),
        meta: { moduleCode: 8010 }
    },
    {
        path: '/subscribers',
        name: 'Manage Subscribers',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/subscribers/subscribersList.vue'),
        meta: { moduleCode: 8009 }
    },
    {
        path: '/subscribers/Edit',
        name: 'Manage Subscribers | Edit Subscriber',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/subscribers/EditSubscription.vue'),
        meta: { moduleCode: 8009 }
    },
    {
        path: '/testimonialList/create',
        name: 'Manage Testimonials | Add/Edit Testimonal',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageTestimonial/addedittestimonial.vue'),
        meta: { moduleCode: 8008 }
    },
    {
        path: '/testimonialList/edit/:id',
        name: 'Manage Testimonials | Add/Edit Testimonial',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageTestimonial/addedittestimonial.vue'),
        meta: { moduleCode: 8008 }
    },
    {
        path: '/testimonialList',
        name: 'Manage Testimonials',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageTestimonial/testimonialList.vue'),
        meta: { moduleCode: 8008 }
    },
    {
        path: '/testimonialcategorylist',
        name: 'Manage Testimonial Categories',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageTestimonial/mangeTestimonialCategory/testimonialcategoryList.vue'),
        meta: { moduleCode: 8008 }
    },

    //For Manage Check List Starts
    {
        path: '/feedback',
        name: 'Manage Feedback Forms',
        beforeEnter: routerGuard.guardMyroute,
        meta: { moduleCode: 6004 },
        component: () =>
            import ('@/views/crm/checklist/viewchecklist.vue'),
    },
    {
        path: '/propertiespopupform',
        name: 'propertiespopupform',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/checklist/propertiespopupform.vue'),
    },
    {
        path: '/feedback/create',
        name: 'Manage Feedback Forms | Add Feedback Form',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/checklist/addeditquestionnaire.vue'),
        meta: { moduleCode: 6004 }
    },
    {
        path: '/feedback/edit/:id',
        name: 'Manage Feedback Forms | Edit Feedback Form',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/checklist/addeditquestionnaire.vue'),
        meta: { moduleCode: 6004 }
    },
    //For Manage Check List Ends

    //For Manage Assets Starts
    {
        path: '/manageassets',
        name: 'Manage Assets',
        beforeEnter: [routerGuard.guardMyroute, routerGuard.guardManageAssetsListRoute],
        meta: { moduleCode: 6005 },
        component: () =>
            import ('@/views/crm/manageassets/assetslist.vue'),
    },
    {
        path: '/manageassets/Create',
        name: 'Manage Assets | Add Asset',
        beforeEnter: routerGuard.guardMyroute,
        meta: { moduleCode: 6005 },
        component: () =>
            import ('@/views/crm/manageassets/addeditasset.vue'),
    },
    {
        path: '/manageassets/Edit/:id',
        name: 'Manage Assets | Edit Asset',
        beforeEnter: routerGuard.guardMyroute,
        meta: { moduleCode: 6005 },
        component: () =>
            import ('@/views/crm/manageassets/addeditasset.vue'),
    },
    {
        path: '/manageassets/AssetDetialView/:id',
        name: 'Manage Assets | Asset Detial',
        //beforeEnter: routerGuard.guardMyroute,
        meta: { moduleCode: 6005 },
        component: () =>
            import ('@/views/crm/manageassets/AssetDetialView.vue'),

    },
    {
        path: '/manageassets/sharehistory/:id',
        name: 'Assets Share History',
        beforeEnter: routerGuard.guardMyroute,
        meta: { moduleCode: 6005 },
        component: () =>
            import ('@/views/crm/manageassets/sharehistory.vue'),

    },

    //For Manage Assets Ends


    {
        path: '/Addedittestimonialcategory',
        name: 'Manage Testimonial Categories | Add/Edit Testimonial Category',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageTestimonial/mangeTestimonialCategory/Addedittestimonialcategory.vue'),
        meta: { moduleCode: 6003 }
    },
    {
        path: '/socialmedialinks',
        name: 'Social Media Links',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managesocialmedialinks/socialmedialinkslist.vue'),
        meta: { moduleCode: 8011 }
    },
    {
        path: '/socialmedialinks/create',
        name: 'Social Media Links | Add/Edit Social Media Link',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managesocialmedialinks/addeditsocialmedialinks.vue'),
        meta: { moduleCode: 8011 }
    },
    {
        path: '/socialmedialinks/edit/:id',
        name: 'Social Media Links | Edit Social Media Link',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managesocialmedialinks/addeditsocialmedialinks.vue'),
        meta: { moduleCode: 8011 }
    },
    {
        path: '/managepackage',
        name: 'Manage package',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managepackages/packagesList.vue'),


    },
    {
        path: '/managepackages/addPackage/:id',
        name: 'Add Package',
        component: () =>
            import ('@/views/managepackages/addPackage.vue'),
        meta: { moduleCode: 8008 }

    },
    {
        path: '/manageDynamicPageContent/AddUpdateDynamicPage',
        name: 'Dynamic Company Pages | Add/Edit Dynamic Page Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageDynamicPageContent/AddUpdateDynamicPage.vue'),
        meta: { moduleCode: 8002 }
    },
    {
        path: '/DynamicPage',
        name: 'Dynamic Company Pages',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageDynamicPageContent/DynamicPageList.vue'),
        meta: { moduleCode: 8002 }
    },
    {
        path: '/DynamicPage/edit/:id',
        name: 'Dynamic Company Page | Add/Edit Dynamic Page Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageDynamicPageContent/AddUpdateDynamicPage.vue'),
        meta: { moduleCode: 8002 }
    },
    // Lead Start
    {
        path: '/leads/addlead',
        name: 'Manage Leads | Add Lead',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/lead/addeditlead.vue'),
        meta: { moduleCode: 7001 }
    },
    {
        path: '/leads/editlead/:id',
        name: 'Manage Leads | Edit Lead',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/lead/addeditlead.vue'),
        meta: { moduleCode: 7001 }
    },
    {
        path: '/leads',
        name: 'Manage Leads',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/lead/leadlist.vue'),
        meta: { moduleCode: 7001 }
    },
    {
        path: '/leads/leadconvert',
        name: 'Manage Leads | lead Convert',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/lead/leadconvertpopup.vue'),
        meta: { moduleCode: 7001 }
    },
    {
        path: '/leads/viewlead/:id',
        name: 'Manage Leads | View lead',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/lead/viewlead.vue'),
        meta: { moduleCode: 7001 }
    },
    // Lead End
    //opportunity Start
    {
        path: '/opportunity',
        name: 'Manage Opportunities',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/opportunity/opportunitylist.vue'),
        meta: { moduleCode: 7004 }
    },
    {
        path: '/opportunity/addopportunity',
        name: 'Manage Opportunities | Add Opportunity',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/opportunity/addeditopportunity.vue'),
        meta: { moduleCode: 7004 }
    },
    {
        path: '/opportunity/editopportunity/:id',
        name: 'Manage Opportunities | Edit Opportunity',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/opportunity/addeditopportunity.vue'),
        meta: { moduleCode: 7004 }
    },
    {
        path: '/opportunity/viewopportunity/:id',
        name: 'Manage Opportunities | View Opportunity',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/opportunity/viewopportunity.vue'),
        meta: { moduleCode: 7004 }
    },
    //opportunity End
    //Contact Start
    ,
    {
        path: '/contact',
        name: 'Manage Contacts',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contact/contactlist.vue'),
        meta: { moduleCode: 7003 }
    },
    {
        path: '/contact/addcontact',
        name: 'Manage Contacts | Add Contact',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contact/addeditcontact.vue'),
        meta: { moduleCode: 7003 }
    },
    {
        path: '/contact/editcontact/:id',
        name: 'Manage Contacts | Edit Contact',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contact/addeditcontact.vue'),
        meta: { moduleCode: 7003 }
    },
    {
        path: '/contact/viewcontact/:id',
        name: 'Manage Contacts | View Contact',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contact/viewcontact.vue'),
        meta: { moduleCode: 7003 }
    },
    //Contact End
    {
        path: '/addstagefieldform',
        name: 'Add Stage Field',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/stageconfiguration/addstagefieldform.vue'),
        meta: { moduleCode: 1015 }

    },
    {
        path: '/timezone',
        name: 'Manage Time Zone',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/managetimezone/managetimezonelist.vue'),
        meta: { moduleCode: 6007 }

    },
    {
        path: '/location',
        name: 'Manage Locations',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/location/locationlist.vue'),
        meta: { moduleCode: 9001 }

    },
    {
        path: '/location/addlocation',
        name: 'Manage Locations | Add Location',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/location/addeditlocation.vue'),
        meta: { moduleCode: 9001 }
    },
    {
        path: '/location/editlocation/:id',
        name: 'Manage Locations | Edit Lead',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/location/addeditlocation.vue'),
        meta: { moduleCode: 9001 }
    },
    {
        path: '/location/viewlocation/:id',
        name: 'Manage Locations | View Location',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/location/viewlocation.vue'),
        meta: { moduleCode: 9001 }
    },
    {
        path: '/serviceterritory',
        name: 'Manage Service Territories',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/serviceterritory/serviceterritorylist.vue'),
        meta: { moduleCode: 1003 }

    },
    {
        path: '/serviceterritory/addserviceterritory',
        name: 'Manage Service Territories | Add Service Territory',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/serviceterritory/addeditserviceterritory.vue'),
        meta: { moduleCode: 1003 }
    },
    {
        path: '/serviceterritory/editserviceterritory/:id',
        name: 'Manage Service Territories | Edit Service Territory',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/serviceterritory/addeditserviceterritory.vue'),
        meta: { moduleCode: 1003 }
    },
    {
        path: '/serviceterritory/viewserviceterritory/:id',
        name: 'Manage Service Territories | View Service Territory',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/serviceterritory/viewserviceterritory.vue'),
        meta: { moduleCode: 1003 }
    },
    {
        path: '/managearticle',
        name: 'Manage Articles',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managearticle/ArticleList.vue'),
        meta: { moduleCode: 8016 }
    },
    {
        path: '/managearticle/AddArticle',
        name: 'Add Article',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managearticle/AddArticle.vue'),
        meta: { moduleCode: 8016 }
    },
    {
        path: '/managearticle/edit/:id',
        name: 'Edit Article',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managearticle/AddArticle.vue'),
        meta: { moduleCode: 8016 }
    },



    //Operating Hour  Start
    {
        path: '/operatinghours',
        name: 'Manage Operating Hours',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/operatinghours/operatinghourlist.vue'),
        meta: { moduleCode: 9002 }
    }
    //Operating Hour End
    ,
    {
        path: '/contactinformation',
        name: 'View Contact Submissions',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managepropertycontactInfo/contactinformation.vue'),
        meta: { moduleCode: 8013 }
    },
    {
        path: '/propertyreview',
        name: 'Manage Asset Reviews',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managepropertyreview/propertyreviewlist.vue'),
        meta: { moduleCode: 1021 }
    },
    {
        path: '/propertyinterestlist',
        name: 'View Assets Interest',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managepropertyinterest/propertyinterestlist.vue'),
        meta: { moduleCode: 8012 }

    },
    {
        path: '/propertyschedulemeetinglist',
        name: 'View Scheduled Meetings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/manageschedulemeeting/schedulemeetinglist.vue'),
        meta: { moduleCode: 8015 }
    },
    {
        path: '/managecourse/create',
        name: 'Manage Courses | Add/Edit Course',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecourse/addeditcourse.vue'),
        meta: { moduleCode: 1023 }

    },
    {
        path: '/managecourse',
        name: 'Manage Courses',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecourse/managecourselist.vue'),
        meta: { moduleCode: 1023 }


    },
    {
        path: '/managecourse/edit/:id',
        name: 'Manage Courses | Edit Course',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecourse/addeditcourse.vue'),
        meta: { moduleCode: 1023 }

    },

    {
        path: '/addMonthlyContent/create',
        name: 'Manage Monthly Content | Add Monthly Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageMonthlyContent/addMonthlyContent.vue'),
        meta: { moduleCode: 8017 }

    },
    {
        path: '/managemonthlycontent',
        name: 'Manage Monthly Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageMonthlyContent/monthlycontentlist.vue'),
        meta: { moduleCode: 8017 }

    },
    {
        path: '/addMonthlyContentEdit/:id',
        name: 'Manage Monthly Content | Edit Monthly Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/manageMonthlyContent/addMonthlyContent.vue'),
        meta: { moduleCode: 8017 }

    },
    {
        path: '/DynamicContent',
        name: 'Home Page Settings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageDynamicContent/EditDynamicContent.vue'),
        meta: { moduleCode: 5214 }

    },
    {
        path: '/DynamicCompanyMenu',
        name: 'Dynamic  Company Pages',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managedynamicmenu/DynamicCompanyMenuList.vue'),
        meta: { moduleCode: 8002 }
    },
    {
        path: '/DynamicCompanyMenu/AddDynamicCompany',
        name: 'Dynamic Company Pages |  Add/Edit Dynamic Page Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managedynamicmenu/AddDynamicCompanyMenu.vue'),
        meta: { moduleCode: 8002 }
    },
    {
        path: '/DynamicCompanyMenu/edit/:id',
        name: 'Dynamic Company Page |  Add/Edit Dynamic Page Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managedynamicmenu/AddDynamicCompanyMenu.vue'),
        meta: { moduleCode: 8002 }
    },
    {
        path: '/traningCategories',
        name: 'Manage Training Categories',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managetrainings/TrainingCategory/categorieslist.vue'),
        meta: { moduleCode: 5806 }
    },
    {
        path: '/traningCategories/addCategory',
        name: 'Manage Training Categories | Add Training Category',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managetrainings/TrainingCategory/addCategory.vue'),
        meta: { moduleCode: 5806 }
    },

    {
        path: '/traningCategories/edit/:TrainingCategoryId',
        name: 'Manage Training Categories | Edit Training Category',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managetrainings/TrainingCategory/addCategory.vue'),
        meta: { moduleCode: 5806 }
    },
    {
        path: '/trainingList',
        name: 'Manage Training Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managetrainings/trainings/traininglist.vue'),
        meta: { moduleCode: 1020 }
    },
    {
        path: '/trainingList/addTraining',
        name: 'Manage Training Content | Add Training',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managetrainings/trainings/addTraining.vue'),
        meta: { moduleCode: 1020 }
    },
    {
        path: '/trainingList/edit/:id',
        name: 'Manage Training Content | Edit Training',
        beforeEach: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managetrainings/trainings/addTraining.vue'),
        meta: { moduleCode: 1020 }
    },
    {
        path: '/communicationList',
        name: 'Manage Communication',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecommunication/usercommunicationlist.vue'),
        meta: { moduleCode: 5807 }
    },
    {
        path: '/communication/send',
        name: 'Add message',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecommunication/sendmessage.vue'),
        meta: { moduleCode: 5807 }
    },
    {
        path: '/communication/forward/:forwardId',
        name: 'forward message',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecommunication/sendmessage.vue'),
        meta: { moduleCode: 5807 }
    },
    {
        path: '/communication/reply/:replyId',
        name: 'reply message',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecommunication/reply.vue'),
        meta: { moduleCode: 5807 }
    },
    {
        path: '/CompanyUser',
        alias: ['/companyuser'],
        name: 'Manage Company Users',
       // beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecompanyusers/CompanyUsersList.vue'),
        meta: { moduleCode: 9010 }

    },
    {
        path: '/CompanyUser/Create',
        name: 'Manage Company Users  | Add Company User',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecompanyusers/AddCompanyUser.vue'),
        meta: { moduleCode: 9010 }
    },
    {
        path: '/CompanyUser/edit/:id',
        name: 'Manage Company Users | Edit Company User',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/managecompanyusers/AddCompanyUser.vue'),
        meta: { moduleCode: 9010 }
    },
    {
        path: '/FAQ',
        name: "Manage FAQs",
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/frequentlyaskedquestion/manageFAQ.vue'),
        meta: { moduleCode: 1001 }
    },
    {
        path: '/addeditFAQ',
        name: "Manage FAQs | Add FAQ",
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/frequentlyaskedquestion/addEditFAQ.vue'),
        meta: { moduleCode: 1001 }
    },
    {
        path: '/addeditFAQ/:id',
        name: "Manage FAQs | Edit FAQ",
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/frequentlyaskedquestion/addEditFAQ.vue'),
        meta: { moduleCode: 1001 }
    },
    {
        path: '/StageConfiguration',
        name: 'Manage Stage Configurations',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/stageconfiguration/stageconfiguration.vue'),
        meta: { moduleCode: 1015 }
    },
    {
        path: '/commisionSetting',
        name: 'Manage Settings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageCommisionSetting/manageCommisionSetting.vue'),
        meta: { moduleCode: 4046 }
    },
    //Proposal Start
    {
        path: '/proposal',
        name: 'Manage Proposals',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/proposal/proposallist.vue'),
        meta: { moduleCode: 7005 }
    },
    {
        path: '/proposal/addProposal',
        name: 'Manage Proposals | Add Proposal',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/proposal/addeditproposal.vue'),
        meta: { moduleCode: 7005 }
    },
    {
        path: '/proposal/editproposal/:id',
        name: 'Manage Proposals | Edit Proposal',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/proposal/addeditproposal.vue'),
        meta: { moduleCode: 7005 }
    },
    {
        path: '/proposal/viewproposal/:id',
        name: 'Manage Proposals | View Proposal',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/proposal/viewproposal.vue'),
        meta: { moduleCode: 7005 }
    },
    //Proposal End
    //Account Start
    ,
    {
        path: '/account',
        name: 'Manage Accounts',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/accountlist.vue'),
        meta: { moduleCode: 7002 }
    },
    {
        path: '/account/addaccount',
        name: 'Manage Accounts | Add Account',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/addeditaccount.vue'),
        meta: { moduleCode: 7002 }
    },
    {
        path: '/account/editaccount/:id',
        name: 'Manage Accounts | Edit Account',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/addeditaccount.vue'),
        meta: { moduleCode: 7002 }
    },
    {
        path: '/account/viewaccount/:id',
        name: 'Manage Accounts | View Account',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/viewaccount.vue'),
        meta: { moduleCode: 7002 }
    },
    //Account End
    //Contract Start
    {
        path: '/contract',
        name: 'Manage Contracts',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contract/contractlist.vue'),
        meta: { moduleCode: 7006 }
    },
    {
        path: '/contract/addContract',
        name: 'Manage Contracts | Add Contract',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contract/addeditcontract.vue'),
        meta: { moduleCode: 7006 }
    },
    {
        path: '/contract/editcontract/:id',
        name: 'Manage Contracts | Edit Contract',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contract/addeditcontract.vue'),
        meta: { moduleCode: 7006 }
    },
    {
        path: '/contract/viewcontract/:id',
        name: 'Manage Contracts | View Contract',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/contract/viewcontract.vue'),
        meta: { moduleCode: 7006 }
    },
    //Contract End
    //workorder Start
    {
        path: '/workorder',
        name: 'Manage Work Orders',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/workorder/workorderlist.vue'),
        meta: { moduleCode: 7007 }
    },
    {
        path: '/workorder/addworkorder',
        name: 'Manage Work Orders | Add Work Order',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/workorder/addeditworkorder.vue'),
        meta: { moduleCode: 7007 }
    },
    {
        path: '/workorder/editworkorder/:id',
        name: 'Manage Work Orders | Edit Work Order',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/workorder/addeditworkorder.vue'),
        meta: { moduleCode: 7007 }
    },
    {
        path: '/workorder/viewworkorder/:id',
        name: 'Manage Work Orders | View Work Order',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/workorder/viewworkorder.vue'),
        meta: { moduleCode: 7007 }
    },
    {
        path: '/InvoicePaymentHistory',
        name: 'InvoicePaymentHistory',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/companysubscription/InvociePaymentHistory.vue'),
        meta: { moduleCode: 4047 }

    },
    {
        path: '/bookProperty',
        name: 'Booking Requests',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageBooking/bookingProperty.vue'),
        meta: { moduleCode: 1022 }

    },

    //workorder End
    //Manage document Start
    {
        path: '/documents',
        name: 'Documents',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/managedocument/managedocumentlist.vue'),
        meta: { moduleCode: 3001 }
    },
    {
        path: '/documents/addDocument',
        name: 'Manage Document | Add Document',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/managedocument/addeditdocument.vue'),
        meta: { moduleCode: 3001 }
    },
    {
        path: '/documents/editdocument/:id',
        name: 'Manage Document | Edit Document',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/managedocument/addeditdocument.vue'),
        meta: { moduleCode: 3001 }
    },
    //Manage document End
    //Document Route Rule Start
    {
        path: '/documentrouterule',
        name: 'Document Route/Rule',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documentrouterule/documentrouterulelist.vue'),
        meta: { moduleCode: 3002 }
    },
    {
        path: '/documentrouterule/adddocumentrouterule',
        name: 'Document Route/Rule | Add Route/Rule',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documentrouterule/addeditdocumentrouterule.vue'),
        meta: { moduleCode: 3002 }
    },
    {
        path: '/documentrouterule/editdocumentrouterule/:id',
        name: 'Document Route/Rule | Edit Route/Rule',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documentrouterule/addeditdocumentrouterule.vue'),
        meta: { moduleCode: 3002 }
    },
    //Document Route Rule End
    //Document Mapping Start
    {
        path: '/documentmapping',
        name: 'Document Mapping',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documentmapping/documentmappinglist.vue'),
        meta: { moduleCode: 3003 }
    },
    {
        path: '/documentmapping/adddocumentmapping',
        name: 'Document Mapping | Add Document Mapping',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documentmapping/documentmappingaddedit.vue'),
        meta: { moduleCode: 3003 }
    },
    {
        path: '/documentmapping/editdocumentmapping/:id',
        name: 'Document Mapping | Edit Document Mapping',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documentmapping/documentmappingaddedit.vue'),
        meta: { moduleCode: 3003 }
    },
    //Document Mapping End

    // Calendar Start
    {
        path: '/calendar',
        name: 'Calendar',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/calendar/calendarlist.vue'),
        meta: { moduleCode: 7008 }
    },

    // Calendar End
    {
        path: '/AddVendor',
        name: 'Manage Vendor  | Add/Edit Vendor',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageVendor/AddVendor.vue'),
        meta: { moduleCode: 1024 }


    },
    {
        path: '/AddVendor/:id',
        name: 'Manage Vendor | Add/Edit Vendor',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageVendor/AddVendor.vue'),
        meta: { moduleCode: 1024 }

    },
    {
        path: '/managevendor',
        name: 'Manage Vendors',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageVendor/ManageVendors.vue'),
        meta: { moduleCode: 1024 }

    },
    {
        path: '/addEditsubadmin',
        name: ' Manage Agents | Add/Edit Agent ',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageSubAdmin/AddSubAdmin.vue'),
        meta: { moduleCode: 1024 }
    },
    {
        path: '/managesubadmin',
        name: 'Manage Agents',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageSubAdmin/subadminList.vue'),
        meta: { moduleCode: 1024 }
    },
    {
        path: '/managesubadmin/addEditsubadmin/:id',
        name: 'Manage Agents | Add/Edit Agent',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageSubAdmin/AddSubAdmin.vue'),
        meta: { moduleCode: 1024 }
    },
    {
        path: '/htmltemplate',
        name: 'HTML Template',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documenthtmlbuilder/documenthtmlbuilderlist.vue')
    },
    {
        path: '/htmltemplate/addhtmltemplate',
        name: 'Add HTML Template',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documenthtmlbuilder/documenthtmlbuilderaddedit.vue')
    },
    {
        path: '/htmltemplate/edithtmltemplate/:id',
        name: 'Edit HTML Template',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/document/documenthtmlbuilder/documenthtmlbuilderaddedit.vue')
    },
    {
        path: '/interestlist',
        name: 'View Interests',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/Managepropertyinterest/interestlist.vue'),
        meta: { moduleCode: 15259 }
    },
    {
        path: '/companyInvoicePackagehistory',
        name: 'Invoice Package History',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageSupInvoicePackageHistory/supinvoicepackagehistory.vue'),
        meta: { moduleCode: 45124 }
    },
    {
        path: '/viewtrainingList',
        name: 'View Training Content',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managetrainings/trainings/viewTrainingContents.vue'),
        meta: { moduleCode: 124515 }
    },
    {
        path: '/VacationCalendarSetup/:id',
        name: 'Vacation Calendar Setup',
        component: () =>
            import ('@/views/AssetReserveBooking/assetReservebooking.vue'),
    },
    {
        path: '/DunningSettings',
        name: 'DunningSettings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageCommisionSetting/ManageDunningSettings.vue'),
        meta: { moduleCode: 4048 }
    },
    {
        path: '/ViewCalendar',
        name: 'ViewCalendar',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ManageBooking/ViewCalendar.vue')
        ,
        meta: { moduleCode: 6005 }

    },
    {
        path: '/videoChat',
        name: 'videoChat',
        component: () =>
            import ('@/views/crm/shared/twilio/videochat/videochat.vue')
    },
    {
        path: '/companyintegration',
        name: 'Manage Company Integration Settings',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/companyintegrationsetting/companyintegrationsettings.vue'),
        meta: { moduleCode: 9002 }
    },
    //Bank Start
    {
        path: '/banks',
        name: 'Manage Banks',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/accountlist.vue'),
        meta: { moduleCode: 1801 },
    },
    {
        path: '/banks/addbank',
        name: 'Manage Banks | Add Bank',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/addeditaccount.vue'),
        meta: { moduleCode: 1801 }
    },
    {
        path: '/banks/editbank/:id',
        name: 'Manage Banks | Edit Bank',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/addeditaccount.vue'),
        meta: { moduleCode: 1801 }
    },
    {
        path: '/banks/viewbank/:id',
        name: 'Manage Banks | View Bank',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/viewbank.vue'),
        meta: { moduleCode: 1801 }
    },
    //Bank End
    //Sub-Dealer Start
    {
        path: '/subdealer',
        name: 'Manage Sub-Dealer',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/accountlist.vue'),
        meta: { moduleCode: 1827 },
    },
    {
        path: '/subdealer/addsubdealer',
        name: 'Manage Sub-Dealers | Add Sub-Dealer',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/addeditaccount.vue'),
        meta: { moduleCode: 1827 }
    },
    {
        path: '/subdealer/editsubdealer/:id',
        name: 'Manage Sub-Dealers | Edit Sub-Dealer',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/addeditaccount.vue'),
        meta: { moduleCode: 1827 }
    },
    {
        path: '/subdealer/viewsubdealer/:id',
        name: 'Manage Sub-Dealers | View Sub-Dealer',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/account/viewsubdealer.vue'),
        meta: { moduleCode: 1827 }
    },
    //Sub-Dealer End
    //Loan Product Start
    {
        path: '/loanproduct',
        name: 'Manage Loan Product',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/loanproduct/loanproductlist.vue'),
        meta: { moduleCode: 1829 },
    },
    {
        path: '/loanproduct/addloanproduct',
        name: 'Manage Loan Product | Add Loan Product',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/loanproduct/addeditloanproduct.vue'),
        meta: { moduleCode: 1829 }
    },
    {
        path: '/loanproduct/editloanproduct/:id',
        name: 'Manage Loan Product | Edit Loan Product',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/loanproduct/addeditloanproduct.vue'),
        meta: { moduleCode: 1829 }
    },
    // {
    //     path: '/loanproduct/viewloanproduct/:id',
    //     name: 'Manage Loan Product | View Loan Product',
    //     beforeEnter: routerGuard.guardMyroute,
    //     component: () =>
    //         import ('@/views/crm/loanproduct/viewloanproduct.vue'),
    //     meta: { moduleCode: 1829 }
    // },
    //Loan Product End

    {
        path: '/ruleengine/addruleengine',
        name: 'Manage Rule Engine | Add Rule Engine',
        // beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/ruleengine/ruleengineaddedit.vue'),
    },
    {
        path: '/ruleengine/editruleengine/:id',
        name: 'Manage Rule Engine | Edit Rule Engine',
        // beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/ruleengine/ruleengineaddedit.vue'),
    },
    {
        path: '/ruleengine',
        name: 'Rule Engine',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/crm/ruleengine/ruleenginelisting.vue'),
        meta: { moduleCode: 1802 }
    },
    {
        path: '/ManageOwnerrez',
        name: 'Manage Ownerrez Credentials ',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManagePaymentSettings/OwnerrezPayment.vue'),
        meta: { moduleCode: 5215 }
    },
    {
        path: '/formconfig',
        name: 'formconfig',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/crm/configurationsetting/form-configlist/form-configlist.component.vue'),
        meta: { moduleCode: 1803 }
    },
    {
        path: '/list/:code',
        name: 'list',
        component: () =>
            import ('@/views/crm/configurationsetting/manageform/formlist/formlist.vue'),
    },
    {
        path: '/addeditform/:module/:subModule/:systemgenerated/:formMasterId',
        name: 'addeditform',
        component: () =>
            import ('@/views/crm/configurationsetting/manageform/addEditForm/addeditform.vue'),
    },
    {
        path: '/RequiredDocuments/:id',
        name: 'Manage Assets | Buy Process Settings',
        component: () =>
            import ('@/views/ManageRequiredDocuments/ManageRequireddocument.vue'),
    },
    {
        path: '/ManagePendingDocuments',
        name: 'ManagePendingDocuments',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageAssetBuyDocuments/ManagePendingDocuments.vue'),
        meta: { moduleCode: 6009 }
    },
    {
        path: '/esignSettings',
        name: 'Account Key',
        component: () =>
            import ('@/views/ManageRequiredDocuments/ManageESignSetting.vue'),
    }, {
        path: '/ManageEmailSetting',
        name: 'Manage Email Setting',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/ManageEmailSetting/ManageEmailSetting.vue'),
             meta: { moduleCode: 45789 }
    },
    {
        path: '/stageconfiglist',
        name: 'StageConfigList',
        component: () =>
            import ('@/views/crm/loanappstageconfig/stageconfiglist.vue'),
        // meta: { moduleCode: 5215 }
    },
    {
        path: '/stageconfig/:code',
        name: 'StageConfig',
        component: () =>
            import ('@/views/crm/loanappstageconfig/stageconfig.vue'),
        // meta: { moduleCode: 5215 }
    },
    {
        path: '/loanApplication',
        name: 'Loan Application',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/loanapplications/newloanapplicationlists.vue'),
        meta: { moduleCode: 1830 }
    },
    {
        path: '/loanApplications/Cancelled',
        name: 'Cancelled Loan Application',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/loanapplications/newloanapplicationlists.vue'),
        meta: { moduleCode: 1831 }
    },
    {
        path: '/loanApplications/Completed',
        name: 'Completed Loan Application',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/loanapplications/newloanapplicationlists.vue'),
        meta: { moduleCode: 1832 }
    },
    {
        path: '/application/:companyId/:accountId/:id/:userId',
        name: 'application',
        component: () =>
            import ('@/views/crm/loanapplications/generateloanapplications.vue'),
    },
    {
        path: '/AddRefund',
        name: 'addRefundDetails',
        component: () =>
            import ('@/views/managerefundpayment/AddRefund.vue'),
    },
    {
        path: '/ManageDocuments/:id',
        name: 'Manage Document',
        component: () =>
            import ('@/views/ManageRequiredDocuments/ManageDocuments.vue'),
    },
    {
        path: '/ManageDocuments/:id/:shareId',
        name: 'Manage Documents',
        component: () =>
            import ('@/views/ManageRequiredDocuments/ManageDocuments.vue'),
    },
    {
        path: '/refundlist',
        name: 'Refund List',
        component: () =>
            import ('@/views/managerefundpayment/refundlist.vue'),
    },
    {
        path: '/DocuSignSetting',
        name: 'Manage DocuSign Settings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ManageDocuSignSetting/ManagedocuSignSetting.vue'),
        meta: { moduleCode: 5216 }
    },
    {
        path: '/TwilioSettings',
        name: 'Manage Twilio Settings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ManageTwilioSetting/ManageTwilioSetting.vue'),
        meta: { moduleCode: 5217 }
    },
   
    {
        path: '/ZoomSettings',
        name: 'Manage Zoom Settings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ManageZoomSetting/ManageZoomSetting.vue'),
        meta: { moduleCode: 5218 }
    },
    {
        path: '/Quicksearchsetting',
        name: 'Manage Quick Search Settings',
        component: () =>
            import('@/views/ManageQuickSettings/ManageQuickSettings.vue'),
      
    },
    {
        path: '/loanApplication/detail/:id',
        name: 'Loan Application | Loan Application Detail',
        component: () =>
            import ('@/views/crm/loanapplication/loanapplicationdetail.vue'),
        meta: { moduleCode: 1830 }
    },
    {
        path: '/loanApplication/Completed/detail/:id',
        name: 'Completed Loan Application | Loan Application Detail',
        component: () =>
            import ('@/views/crm/loanapplication/loanapplicationdetail.vue'),
        meta: { moduleCode: 1830 }
    },
    {
        path: '/loanApplication/Cancelled/detail/:id',
        name: 'Cancelled Loan Application | Loan Application Detail',
        component: () =>
            import ('@/views/crm/loanapplication/loanapplicationdetail.vue'),
        meta: { moduleCode: 1830 }
    },
    {
        path: '/uploadfiles/upload/:id/:accid/:userId/:companyId',
        name: 'uploadfiles',
        component: () =>
            import ('@/views/crm/loanapplications/uploaddocument.vue'),
    },
    {
        path: '/layoutform',
        name: 'Manage Layout Form',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/crm/layoutfreeform/layoutfreeformlisting.vue'),
        meta: { moduleCode: 6003 }
    },
    {
        path: '/layoutform/addformfield/:masterid',
        name: 'Manage Layout Form Fields',
        component: () =>
            import ('@/views/crm/layoutfreeform/LayoutFreeFormDesign.vue'),
    },
    
    {
        path: '/manageServer',
        name: 'manageServer',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/manageblogs/manageServer.vue'),
        meta: { moduleCode: 8004 }
    },
    {
        path: '/dynamicDashboard',
        name: 'Edit Dashboard',
        component: () =>
            import('@/views/dashboard/companyadmindashboard/EditdynamicDashboard.vue'),
    },
    {
        path: '/AddInquiry',
        name: 'Add Inquiry',
        component: () =>
            import('@/views/Inquiry/addInquiry.vue'),
    },
    {
        path: '/OwnerrezBookingListing',
        name: 'OwnerrezBookingListing',
        component: () =>
            import('@/views/OwnerrezProperty/OwnerrezBookingListing.vue'),
    },
    
    
    {
        path: '/Inquirylist',
        name: 'Manage Inquiry',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Inquiry/Inquirylist.vue'),
        meta: { moduleCode: 7013 }
    },
    {
        path: '/OwnerrezQuoteListing',
        name: 'QuoteListing',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnerrezProperty/QuoteListing.vue'),
        meta: { moduleCode: 7013 }
    
    },
    {
        path: '/OwnerrezQuoteListing/AddQuote',
        name: 'AddQuote',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnerrezProperty/AddQuote.vue'),
        meta: { moduleCode: 7013 }
    },
    {
        path: '/OwnerrezQuoteListing/QuoteDetails/:id',
        name: 'QuoteDetails',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnerrezProperty/QuoteDetails.vue'),
        meta: { moduleCode: 7013 }

    },
    {
        path: '/OwnerezBookingList',
        name: 'OwnerezBookingList',
     
        component: () =>
            import('@/views/OwnerrezProperty/OwnerrezBookingListing.vue'),
  
    },
    {
        path: '/viewInquiry/:Id',
        name: 'View Inquiry',
        component: () =>
            import('@/views/Inquiry/viewInquiry.vue'),
    },
    {
        path: '/SeasonListings',
        name: 'SeasonListings',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Seasons/SeasonListings.vue'),
        meta: { moduleCode: 7013 }

    },
    {
        path: '/SeasonListings/AddSeason',
        name: 'AddSeason',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Seasons/AddSeason.vue'),
        meta: { moduleCode: 7013 }
    },
    //{
    //    path: '/CheckInChkOut',
    //    name: 'Time Zones &amp; Check-In / Out ',
    //    beforeEnter: routerGuard.guardMyroute,

    //    component: () =>
    //        import('@/views/Rules/CheckInCheckOut.vue'),
    //    meta: { moduleCode: 45709 }

    //},
    {
        path: '/owzcancellationpolicies',
        name: 'Cancellation Policies',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Rules/CancellationPolicies.vue'),
        meta: { moduleCode: 45708 }
    },
    {
        path: '/owzcancellationpolicies/AddEditCanPolicy',
        name: 'Add/Edit Cancellation Policies',

        component: () =>
            import('@/views/Rules/addeditCancellationPolicy.vue'),
        meta: { moduleCode: 45708 }

    },
    {
        path: '/conversation/:inquiryId/:moduleName',
        name: 'Conversation',

        component: () =>
            import('@/views/Inquiry/conversation.vue'),

    },
    {
        path: '/discounts',
        name: 'Manage Discounts',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
        import('@/views/Pricing/manageDiscounts.vue'),
        meta: { moduleCode: 7016 }
    },
    {
        path: '/adddiscount',
        name: 'Add Discount',
        component: () =>
        import('@/views/Pricing/addDiscount.vue'),

    },
    {
        path: '/taxes',
        name: 'Manage Taxes',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
        import('@/views/Pricing/manageTaxes.vue'),
        meta: { moduleCode: 7017 }

    },
    {
        path: '/addtaxes',
        name: 'Add Taxes',
        component: () =>
            import('@/views/Pricing/addTaxes.vue'),

    },
    {
        path: '/Pricing',
        name: 'PricingPreference',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnerRazePricing/PricingPreferenceListing.vue'),
        meta: { moduleCode: 7013 }
    },
    {
        path: '/holidays',
        name: 'Holidays',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Rules/holidays.vue'),
        meta: { moduleCode: 45710 }
    },
    {
        path: '/holidays/addholiday',
        name: '/holidays/addholiday',

        component: () =>
            import('@/views/Rules/AddHolidays.vue'),
        meta: { moduleCode: 45710 }

    },
    {
        path: '/rates',
        name: 'Rates',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Pricing/Rates/rates.vue'),
        meta: { moduleCode: 7013 }
    },
    {
        path: '/holidays/holidaysOptions',
        name: '/holidays/holidaysOptions',

        component: () =>
            import('@/views/Rules/holidaysOptions.vue'),

    },
    {
        path: '/SeasonListings/EditSeason/:id',
        name: 'SeasonListings | Add/Edit Season',
   
        component: () =>
            import('@/views/Seasons/AddSeason.vue'),
     
    },
    {
        path: '/holidays/Editholidays/:id',
        name: 'holidays | Add/Edit holidays',

        component: () =>
            import('@/views/Rules/AddHolidays.vue'),

    },
    //For 
    {
        path: '/holidays/Editholidays/:id',
        name: 'holidays | Add/Edit holidays',

        component: () =>
            import('@/views/Rules/AddHolidays.vue'),

    },
    //Dynamic Reporting Start
    {
        path: '/reportinglist',
        name: 'Manage Dynamic Report',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/dynamicreporting/reportinglist.vue'),
        //meta: { moduleCode: 1801 },
    },
    {
        path: '/dynamicreport/viewreport/:id',
        name: 'Manage Dynamic Report | View Report',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/crm/dynamicreporting/viewreport.vue'),
        //meta: { moduleCode: 1801 },
    },
    //Dynamic Reporting End

    // New Report Module (12 mandatory reports)
    {
        path: '/reports/new-report',
        name: 'NewReportsIndex',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/index.vue'),
        meta: { moduleCode: 2312 }
    },
    {
        path: '/reports/new-report/executive-dashboard',
        name: 'ExecutiveDashboardReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/ExecutiveDashboardReport.vue'),
        meta: { moduleCode: 2312 }
    },
    {
        path: '/reports/new-report/asset-inventory',
        name: 'AssetInventoryReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 6005, reportKey: 'asset-inventory' }
    },
    {
        path: '/reports/new-report/co-owner-allocation',
        name: 'CoOwnerAllocationReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 6005, reportKey: 'co-owner-allocation' }
    },
    {
        path: '/reports/new-report/booking-summary',
        name: 'BookingSummaryReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 1022, reportKey: 'booking-summary' }
    },
    {
        path: '/reports/new-report/fair-share-utilization',
        name: 'FairShareUtilizationReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 1022, reportKey: 'fair-share-utilization' }
    },
    {
        path: '/reports/new-report/expense-summary',
        name: 'ExpenseSummaryReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 12802, reportKey: 'expense-summary' }
    },
    {
        path: '/reports/new-report/outstanding-dues',
        name: 'OutstandingDuesReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 12803, reportKey: 'outstanding-dues' }
    },
    {
        path: '/reports/new-report/payment-collection',
        name: 'PaymentCollectionReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 12802, reportKey: 'payment-collection' }
    },
    {
        path: '/reports/new-report/open-tickets',
        name: 'OpenTicketsReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 7011, reportKey: 'open-tickets' }
    },
    {
        path: '/reports/new-report/ticket-summary',
        name: 'TicketSummaryReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 7011, reportKey: 'ticket-summary' }
    },
    {
        path: '/reports/new-report/esign-buy-process',
        name: 'EsignBuyProcessReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 6009, reportKey: 'esign-buy-process' }
    },
    {
        path: '/reports/new-report/company-directory',
        name: 'CompanyDirectoryReport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/new-report/NewReportPage.vue'),
        meta: { moduleCode: 4023, reportKey: 'company-directory' }
    },
    {
        path: '/reports/spliytreport',
        name: 'Spliytreport',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/reports/spliytreport/Spliytreport.vue'),
        meta: { moduleCode: 2312 }
    },
    // New Report Module End

    {
        path: '/Rules/addeditCancellationPolicy/:id',
        name: 'Rules |addeditCancellationPolicys',

        component: () =>
            import('@/views/Rules/addeditCancellationPolicy.vue'),

    },
    {
        path: '/addtaxes/edit/:id',
        name: 'Add Taxes|  Edit Pricing',
        component: () =>
            import('@/views/Pricing/addTaxes.vue'),

    },
    {
        path: '/adddiscount/:Id',
        name: 'Add  Discount',
        component: () =>
            import('@/views/Pricing/addDiscount.vue'),

    },
    {
        path: '/Rules/Flatfees/',
        name: 'Rules |Flatfees',

        component: () =>
            import('@/views/Rules/Flatfees.vue'),

    },
    {
        path: '/AddCheckInCheckOut',
        name: 'AddCheckInCheckOut',

        component: () =>
            import('@/views/Rules/AddCheckInCheckOut.vue'),

    },
    {
        path: '/OwnrezInqAnswer/:Id/:redirectFrom',
        name: 'OwnrezInqAnswer',
        component: () =>
            import('@/views/Inquiry/OwnrezInqAnswer.vue')
    },
    {
        path: '/manageassets/ManageRooms/:id',
        name: 'ManageRooms',
        component: () =>
            import('@/views/crm/manageassets/managerooms.vue')
    },
    {
        path: '/manageassets/guestInstructions/:id',
        name: 'GuestInstructions',
        component: () =>
            import('@/views/crm/manageassets/GuestInstructions.vue')
    },
    {
        path: '/manageassets/AddOnCharges/:id',
        name: 'Add-On_charges',
        component: () =>
            import('@/views/crm/manageassets/AddOnCharges.vue')
    },

    {
        path: '/manageassets/AddHealthAndSafety/:id',
        name: 'AddHealthAndSafety',
        component: () =>
            import('@/views/OwnwrRezBookings/AddHealthAndSafety.vue')

    },
       {
           path: '/TicketList/:Id',
           name: 'Ticket List',
        component: () =>
            import('@/views/crm/manageassets/TicketList.vue'),

    },
    {
        path: '/manageassets/ManageRules/:id',
        name: 'ManageRules',
        component: () =>
            import('@/views/crm/manageassets/ManageRules.vue')
    },
    {
        path: '/SummaryReports',
        name: 'SummaryReports',
        component: () =>
            import('@/views/reports/SummaryReports.vue'),

    },
    {
        path: '/reports/StayReports',
        name: 'StayReports',
        component: () =>
            import('@/views/reports/StayReports.vue')
    },
    {
        path: '/reports/HouseKeepingReports',
        name: 'HouseKeepingReports',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/reports/HouseKeepingReports.vue'),
         meta: { moduleCode: 45706 },

    },
    {
        path: '/reports/CancellationReports',
        name: 'CancellationReports',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/reports/CancellationReports.vue'),
        meta: { moduleCode: 45707 },
    },
    {
        path: '/SetupSchedulingRule',
        name: 'SetupSchedulingRule',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/SetupSchedulingRule/SetupSchedulingRule.vue'),
        meta: { moduleCode: 12704 },
    },
    {
        path: '/CheckLists',
        name: 'Check Lists',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ManageCheckList/CheckLists.vue'),
        meta: { moduleCode: 12706 },
    },
    {
        path: '/CheckLists/AddCheckLists',
        name: 'AddCheckLists',
        component: () =>
            import('@/views/ManageCheckList/AddCheckLists.vue')
    },
    {
        path: '/CheckLists/AddCheckLists/:Id',
        name: 'EditCheckLists',
        component: () =>
            import('@/views/ManageCheckList/AddCheckLists.vue')
    },
    {
        path: '/Schedule',
        name: 'Schedule',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/SetupSchedulingRule/Schedule.vue'),
        meta: { moduleCode: 12708 },
    },
    {
        path: '/ManageGroup',
        name: 'ManageGroup',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ManageGroup/managegroup.vue'),
        meta: { moduleCode: 12707 },
    },
    {
        path: '/HouseKeepingDashboard1',
        name: 'HouseKeepingDashboard1',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/HouseKeeping/HouseKeepingDashboard1.vue'),
        meta: { moduleCode: 12701 },
    },
    {
        path: '/HouseKeepingDashboard_2',
        name: 'HouseKeepingDashboard_2',
        component: () =>
            import('@/views/HouseKeeping/HouseKeepingDashboard_2.vue')
    },
    {
        path: '/ManageGroup/AddGroup',
        name: 'AddGroup',
        component: () =>
            import('@/views/ManageGroup/AddGroup.vue')
    },
    {
        path: '/ManageGroup/AddGroup/:id',
        name: 'AddGroups',
        component: () =>
            import('@/views/ManageGroup/AddGroup.vue')
    },
    {
        path: '/experiencelist',
        name: 'Experience List',
        component: () =>
            import('@/views/ManageExperience/experienceList.vue')
    },
    {
        path: '/TimeSlot',
        name: 'Manage Time Slot',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/ManageTimeSlot/timeSlot.vue'),
        meta: { moduleCode: 52165216 }

        //5216

    },
    {
        path: '/manageassets/ManageCarts/:id',
        name: 'ManageCarts',
        component: () =>
            import('@/views/crm/manageassets/ManageCarts.vue')
    },
    {
        path: '/manageassets/ManageTimings',
        name: 'Manage Timings',
        component: () =>
            import('@/views/crm/manageassets/ManageTimings.vue')
    },
    {
        path: '/manageassets/ViewCartBookings',
        name: 'ManageCartBookings',
        component: () =>
            import('@/views/crm/manageassets/ViewCartBookings.vue')
    },
    {
        path: '/insurance',
        name: 'Manage Insurance',
        component: () =>
            import('@/views/Pricing/manageInsurance.vue'),

    },

    {
        path: '/addinsurance',
        name: 'Add Insurance',
        component: () =>
            import('@/views/Pricing/addInsurance.vue'),

    },
    {
        path: '/editInsurance/:Id',
        name: 'Edit Insurance',
        component: () =>
            import('@/views/Pricing/addInsurance.vue'),

    },
    {
        path: '/Promocode/PromocodeList',
        name: 'Promo Codes',
        beforeEnter: routerGuard.guardMyroute,
        component: () => import('@/views/Promocode/PromocodeList.vue'),

        meta: { moduleCode: 8025 }
    },
    {
        path: '/Promocode/AddPromoCode',
        name: 'Promo Codes | Add Promo Code',
        component: () => import('@/views/Promocode/AddPromoCode.vue'),
        meta: { moduleCode: 8025 }
    },
    {
        path: '/Promocode/AddEditPromoCode/:PromoMethodId',
        name: 'Promo Codes | Edit Promo Code',
        component: () =>
            import('@/views/Promocode/AddPromoCode.vue'),
        meta: { moduleCode: 8025 }
    },
    {
        path: '/CustomerExperiencelist',
        name: 'Experience Customer',
        component: () =>
            import('@/views/ManageExperience/CustomerExpBookingListing.vue')
    },
    {
        path: '/ManageSecurityDeposit',
        name: 'Manage Security Deposit',
        component: () =>
            import('@/views/ManageSecurityDeposit/managesecuritydeposit.vue'),
        meta: { moduleCode: 9025 }
    },

    {
        path: '/manageassets/tokenhistory/:id',
        name: 'Token History',
        beforeEnter: routerGuard.guardMyroute,
        meta: { moduleCode: 6005 },
        component: () =>
            import('@/views/crm/manageassets/TokenDetails.vue'),

    },
    {
        path: '/ManageTokens',
        name: 'Manage Tokens',
        component: () =>
            import('@/views/ManageTokens/ManageTokens.vue'),
        meta: { moduleCode: 2004 }
    },
    {
        path: '/MyToken',
        name: 'My Token',
        component: () =>
            import('@/views/MyToken/MyToken.vue'),
        meta: { moduleCode: 2005 }
    },
    {
        path: '/DashboardLanding/:UserName/:origin/:companyUrl',
        name: 'DashboardLanding',
        component: () =>
            import('@/views/DashboardLanding/DashboardLanding.vue'),
        
    },
    {
        path: '/ViewSentInvitations',
        name: 'View Sent Invitations',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/crm/manageassets/ViewSentInvitations.vue'),
        meta: { moduleCode: 6005 }
    },
    {
        path: '/manageassets/ManageCoOwner/:id',
        name: 'coowner',
        component: () =>
            import('@/views/crm/manageassets/managecoowner.vue'),
   },

]



export default routes